import type { ComponentProps } from 'react';

import * as ProgressPrimitive from '@radix-ui/react-progress';
import { cn } from '@repo/lib/cn';

function Progress(progressProps: ComponentProps<typeof ProgressPrimitive.Root>) {
  const { className, value, ...props } = progressProps;
  return (
    <ProgressPrimitive.Root data-slot="progress" className={cn('bg-fill-secondary relative h-1 w-full overflow-hidden rounded-lg', className)} {...props}>
      <ProgressPrimitive.Indicator data-slot="progress-indicator" className="bg-brand h-full w-full flex-1 transition-all" style={{ transform: `translateX(-${100 - (value || 0)}%)` }} />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
